module.exports = __webpack_public_path__ + "img/bbq-secrets-brand-horizontal.f32d5164.jpg";